import { forwardRef, useEffect, useState } from 'react';
import { LoadCrossword } from '../../Actions';
import { date_to_nice_date } from "../../utils";


const MotsHistory = forwardRef((props, ref) => {
	const [previousCrosswords, setPreviousCrosswords] = useState('Carregant...');

	useEffect(() => {
		const setCrossword = (newData) => {
			LoadCrossword(ref, newData, props.setCrosswordData, props.setOnce);
		}

		// Get the data from the props
		const data = props.allCrosswords

		let previousCrosswords = []
		if (data) {
			data.forEach((crossword) => {
				let id = crossword._id.$oid
				let date = date_to_nice_date(new Date(crossword.date.$date))
				let dotted_date = date_to_nice_date(new Date(crossword.date.$date), 'dotted')
				let data = crossword.content
				previousCrosswords.unshift(<div key={id}>
					<div className="cursor-pointer" onClick={() => setCrossword({ content: data, date: dotted_date })}>{date}</div>
				</div>)
			})
			previousCrosswords = previousCrosswords.filter((previousCrossword, index) => index < 10)
			previousCrosswords.shift()
			setPreviousCrosswords(previousCrosswords)
		}

	}, [props, ref]);

	return (
		<div className="history">
			<div className="uppercase font-bold category-title pb-4">Minimots anteriors</div>
			<div className="text-orange_text mots-previous">
				{previousCrosswords}
			</div>
		</div>
	);
})
export default MotsHistory;
